import { createContext, useContext } from 'react';
import { getColorPickerDataProvider } from './__internal__';
import { jsx as _jsx } from "react/jsx-runtime";
const ColorPickerContext = /*#__PURE__*/createContext(undefined);
export const useColorPickerService = () => {
  return useContext(ColorPickerContext);
};
export const ColorPickerProvider = props => {
  return /*#__PURE__*/_jsx(ColorPickerContext.Provider, {
    value: props.value ?? getColorPickerDataProvider(),
    children: props.children
  });
};
//# sourceMappingURL=ColorPickerProvider.js.map